import { Textarea } from '@fluentui/react-components';
import styled from 'styled-components';

export const DescriptionContent = styled(Textarea)`
  border: 1px solid ${(props) => props.theme.popupInputBorderColor};
  border-radius: 4px;
  padding: 0px 10px 0px 10px;
  cursor: default;

  &:hover {
    border: 1px solid ${(props) => props.theme.popupInputBorderColor};
    border-radius: 4px;
  }
`;
